import { FormEvent, useState } from 'react';
import { resolveMeetingJoinCode } from '../lib/api';
import { isValidMeetingJoinCode, normalizeMeetingJoinCode } from '../lib/utils';
import { useToast } from '../context/ToastContext';

interface MeetingCodeFormProps {
  onResolved: (meetingId: string) => void;
  buttonLabel?: string;
  compact?: boolean;
  autoFocus?: boolean;
}

export default function MeetingCodeForm({
  onResolved,
  buttonLabel = 'Sertai Mesyuarat',
  compact = false,
  autoFocus = false,
}: MeetingCodeFormProps) {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const { showToast } = useToast();

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!isValidMeetingJoinCode(code)) {
      showToast('Kod mesyuarat tidak ditemui atau tidak tersedia hari ini.', 'error');
      return;
    }

    setBusy(true);
    try {
      const meetingId = await resolveMeetingJoinCode(code);
      if (!meetingId) throw new Error('CODE_NOT_FOUND');
      onResolved(meetingId);
    } catch {
      showToast('Kod mesyuarat tidak ditemui atau tidak tersedia hari ini.', 'error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className={compact ? 'meeting-code-form meeting-code-form-compact' : 'form-stack'}>
      <label className={compact ? 'field meeting-code-field' : 'field'}>
        <span>Kod Mesyuarat</span>
        <input
          autoFocus={autoFocus}
          value={code}
          onChange={(event) => setCode(normalizeMeetingJoinCode(event.target.value).slice(0, 6))}
          placeholder="R7K4P2"
          autoComplete="off"
          inputMode="text"
          required
          maxLength={6}
          className="join-code-input"
        />
      </label>
      <button className={`button button-primary${compact ? '' : ' button-block'}`} disabled={busy}>
        {busy ? 'Sedang menyertai…' : buttonLabel}
      </button>
    </form>
  );
}
